import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";

import { cn } from "@/lib/utils";

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
  visible?: boolean;
}
>(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      visible = true,
      ...props
    },
    ref,
  ) => {
    if (!visible) return null;
    return (
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={cn(
          "shrink-0 bg-border",
          orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
          className,
        )}
        {...props}
      />
    );
  },
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

const SeparatorWithText = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
  text: string;
  textClassName?: string;
}
>(({ text, textClassName, className, orientation, decorative, ...props }, ref) => {
  return (
    <div className="flex items-center gap-2 w-full">
      <p
        className={cn(
          "text-sm text-slate-700 whitespace-nowrap",
          textClassName,
        )}
      >
        {text}
      </p>
      <Separator
        ref={ref}
        className={cn("flex-1", className)}
        orientation={orientation}
        decorative={decorative}
        {...props}
      />
    </div>
  );
});

SeparatorWithText.displayName = "SeparatorWithText";
export { Separator, SeparatorWithText };
